<template>
	<section>
		<compFormEdit :formdata="getBase" v-model="formData" placeholder="--"></compFormEdit>
		<compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false">
			<component
				v-if="modalProps.component"
				:is="modalProps.component"
				v-bind="modalProps.props"
				v-on="modalProps.on"
			/>
		</compModal>
		<vButtonGroup slot="footer" class="text-right">
			<vButton theme="primary" @click="submit">确认</vButton>
			<vButton @click="close">取消</vButton>
		</vButtonGroup>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import mixin from '../mixins'
import compFindMember from './currentmember.js';
import { HttpAddDept, HttpGetDeptDetail } from '@/service/department/departmentmanage.js'

export default {
    props: ['selectDeptId','type','deptList'],
    mixins: [ mixin ],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compModal: () => import("@components/templates/modal"),
		compFindMember,
	},
	data() {
		return {
			formData: {
                deptMaster: []
            },
			loading: false,
			modalProps: {
				show: false,
			},
            isRoot: false,
            master: [],
            masterId: [],
		};
	},
    created(){
        if(this.type == 'edit'){
            this.getDetail()
        }
    },
    watch: {
        selectDeptId: {
            immediate: true,
            handler (val) {
                let cuttentDept = this.deptList.filter(item => item.id == val)[0] || {};
                this.isRoot = cuttentDept.root;
                this.formData.parentId = this.type == 'edit' ? this.isRoot ? '' : cuttentDept.parentId : cuttentDept.id
            }
        }
    },
	computed: {
		getBase() {
			return [{
                label: "部门ID",
				key: "id",
				tag: "Input",
                span: 24,
                show: this.type == 'edit',
                query: true,
            },
            {
				label: "部门名称",
				key: "name",
				tag: "Input",
                span: 24,
			},
            {
				label: "上级部门",
				key: "parentId",
				tag: "Select",
                options: this.type == 'edit' ? this.deptList.filter(i=> i.id !== this.formData.id ).map(item=>{
                    let parentDept = this.deptList.filter(item1 => item1.id == item.parentId)[0] || {};
                    return {
                        label: item.root ? item.name : `${item.name}(${parentDept.name})`,
                        value: item.id
                    }
                }) : this.deptList.map(item=>{
                    let parentDept = this.deptList.filter(item1 => item1.id == item.parentId)[0] || {};
                    return {
                        label: item.root ? item.name : `${item.name}(${parentDept.name})`,
                        value: item.id
                    }
                }),
                props: {
					filterable: true,
                },
                span: 24,
                query: this.isRoot && this.type == 'edit',
			},
			{
				label: "部门主管",
				tag: "vInput",
				key: "deptMaster",
				props: {
                    placeholder: '点击放大镜搜索',
					suffix: "search",
					readonly: true,
				},
				required: false,
				on: {
					'on-icon-click': this.handleModal
				},
                span: 24,
                show: this.type == 'edit'
			},
			{
				label: "部门编号",
				key: "code",
                tag: "Input",
				required: false,
                span: 24,
                query: this.isRoot && this.type == 'edit',
			},
			{
				label: "备注",
				key: "description",
				tag: "vTextarea",
				required: false,
                span: 24,
			},
			];
		},

	},
	methods: {
        handleModal() {
			this.modalProps = {
				show: true,
				width: 'large',
				title: '查找员工',
				component: "compFindMember",
				showFooter: false,
				props: {
                    selectDeptId: this.selectDeptId,
				},
				on: {
					'on-data': (row) => {
                        // this.master.push(row.name)
                        if(this.masterId.indexOf(row.id) === -1){
                            this.masterId.push(row.id)
                        }
						// this.formData = { deptMaster: this.master, ...this.formData };
                        if(this.formData.deptMaster.indexOf(row.name) === -1){
						    this.formData.deptMaster.push(row.name)
                        }
						this.modalProps = {};
					}
				}
			}
		},
        getDetail(){
            this.loading = true;
            HttpGetDeptDetail({id:this.selectDeptId}).then( res => {
                let array = []
                this.formData = res.data
                res.data.managerInfo.map( item => {
                    array.push(item.name)
                    this.masterId.push(item.emplId)
                })
                console.log('this.masterId',this.masterId)
                this.formData.deptMaster = array
                this.loading = false;
            },err=>{
                this.$Message.error({content: err.message, duration: 10, closable: true})
                this.loading = false;
            })
        },
		close() {
			this.$emit('on-close');
		},
		async submit() {
			this.loading = true;
            if(this.type == 'add'){
                this.formData.id = ''
            }
            delete this.formData.deptMaster
            HttpAddDept(this.formData,{managers:this.masterId}).then( res => {
                this.$Message.success({content: '操作成功', duration: 10, closable: true})
                this.$emit('on-update');
                this.loading = false;
                this.close()
            },err=>{
                this.$Message.error({content: err.message, duration: 10, closable: true})
                this.loading = false;
            })
		}
	}
};
</script>
